import { NIL } from "uuid";

export default interface IArea {
  id: string;
  name: string;
  subDivisionId: string;
  subDivision: any;
  subDivisionName?: string;
  countryId: string;
  country: any;
  countryName?: string;
  code: string;
  isCountryActivated: boolean;
}

export const EmptyArea: IArea = {
  id: NIL,
  subDivisionId: NIL,
  countryId: NIL,
  name: "",
  subDivision: undefined,
  country: "",
  code: "",
  isCountryActivated: false,
};
